import { getCookie } from './getCookie';
import { isEmpty } from './isEmpty';

export const getFeatureToggleCookie = () => {
  let userToggleValues = getCookie('OU_FeatureToggle');

  const [id, key] = userToggleValues.split('|');

  if (isEmpty(id) || isEmpty(key)) {
    return undefined;
  }

  return {
    id,
    key,
  };
};
